// import React from "react";
// import { Box, Container, Grid, Typography } from "@mui/material";
// import AnimatedSection from "../common/AnimatedSection";
// import SectionHeading from "../common/SectionHeading";

// const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const PURPLE = "#845EF7";

// /* Animated school bus SVG */
// const BusSVG = () => (
//   <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width:"100%", maxWidth:320, height:"auto", animation:"floatY 3s ease-in-out infinite" }}>
//     <rect width="320" height="180" rx="16" fill="#1B1F3B"/>
//     {/* Road */}
//     <rect x="0" y="140" width="320" height="40" fill="#2A2A2A" rx="0"/>
//     {[20,60,100,140,180,220,260].map(x=><rect key={x} x={x} y="155" width="30" height="4" fill="#FFD93D" rx="2"/>)}
//     {/* Bus */}
//     <g style={{ animation:"floatY 2s ease-in-out infinite", transformOrigin:"160px 110px" }}>
//       <rect x="30" y="80" width="220" height="70" rx="12" fill={YELLOW} stroke={NAVY} strokeWidth="2.5"/>
//       <rect x="30" y="80" width="48" height="70" rx="12" fill={CORAL} stroke={NAVY} strokeWidth="2"/>
//       <rect x="38" y="92" width="24" height="22" rx="4" fill="#C8F5FF" stroke={NAVY} strokeWidth="1.5"/>
//       {[90,130,170].map(x=><rect key={x} x={x} y="90" width="32" height="22" rx="4" fill="#C8F5FF" stroke={NAVY} strokeWidth="1.5"/>)}
//       <circle cx="90" cy="145" r="16" fill={NAVY}/><circle cx="90" cy="145" r="8" fill="#666"/>
//       <circle cx="220" cy="145" r="16" fill={NAVY}/><circle cx="220" cy="145" r="8" fill="#666"/>
//       <rect x="250" y="84" width="18" height="12" rx="3" fill={TEAL} stroke={NAVY} strokeWidth="1.5"/>
//       <text x="120" y="124" fontFamily="Fredoka One, cursive" fontSize="11" fill={NAVY} fontWeight="bold">SCHOOL BUS</text>
//     </g>
//     {/* Stars */}
//     <text x="20" y="50" fontSize="16" style={{ animation:"starSpin 3s linear infinite" }}>⭐</text>
//     <text x="280" y="55" fontSize="14" style={{ animation:"starSpin 4s linear infinite reverse" }}>✨</text>
//   </svg>
// );

// const ICONS = ["🚌", "🛡️", "💚"];
// const COLORS = [YELLOW, TEAL, CORAL];

// const TransportSafetySection = ({ cards, schoolInfo }) => (
//   <AnimatedSection sx={{ backgroundColor: NAVY, py: { xs: 9, md: 12 } }}>
//     <Container maxWidth="xl">
//       <SectionHeading
//         eyebrow="Safety & Transport"
//         title="Safe Journeys, Happy Arrivals 🚌"
//         description="We take the safety and wellbeing of every child seriously — from campus to doorstep."
//         dark
//         eyebrowColor={YELLOW}
//         eyebrowBg="rgba(255,211,61,0.15)"
//       />

//       <Grid container spacing={4} alignItems="center">
//         <Grid item xs={12} md={5}>
//           <BusSVG />
//           {/* Address card */}
//           <Box sx={{ mt:3, p:3, borderRadius:"16px", border:`2.5px solid ${YELLOW}`, backgroundColor:"rgba(255,211,61,0.08)", boxShadow:`5px 5px 0 ${YELLOW}` }}>
//             <Typography sx={{ fontFamily:"'Fredoka One',cursive", fontSize:"1.1rem", color:YELLOW, mb:1.5 }}>📍 School Address</Typography>
//             <Typography sx={{ color:"rgba(255,248,240,0.75)", fontWeight:600, lineHeight:1.9, fontSize:"0.9rem" }}>
//               {schoolInfo.addressLines.join(", ")}
//             </Typography>
//           </Box>
//         </Grid>

//         <Grid item xs={12} md={7}>
//           <Box sx={{ display:"flex", flexDirection:"column", gap:2.5 }}>
//             {cards.map((c, i) => (
//               <Box key={i} sx={{ display:"flex", gap:2.5, p:3, borderRadius:"16px", border:`2.5px solid ${COLORS[i]}`, backgroundColor:"rgba(255,255,255,0.04)", boxShadow:`5px 5px 0 ${COLORS[i]}`, transition:"all 0.2s", "&:hover":{ transform:"translate(-2px,-2px)", boxShadow:`7px 7px 0 ${COLORS[i]}` } }}>
//                 <Box sx={{ width:52, height:52, flexShrink:0, borderRadius:"14px", backgroundColor:COLORS[i], border:`2px solid ${NAVY}`, display:"grid", placeItems:"center", fontSize:"1.5rem", animation:`bounce ${2.2+i*0.4}s ease-in-out infinite` }}>
//                   {ICONS[i]}
//                 </Box>
//                 <Box>
//                   <Typography sx={{ fontFamily:"'Fredoka One',cursive", fontSize:"1.15rem", color:COLORS[i], mb:0.5 }}>{c.title}</Typography>
//                   <Typography sx={{ color:"rgba(255,248,240,0.75)", fontWeight:600, lineHeight:1.7, fontSize:"0.9rem" }}>{c.description}</Typography>
//                 </Box>
//               </Box>
//             ))}
//           </Box>
//         </Grid>
//       </Grid>
//     </Container>
//   </AnimatedSection>
// );

// export default TransportSafetySection;
















import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const NAVY = "#1B1F3B";
const CORAL = "#FF6B6B";
const YELLOW = "#FFD93D";
const TEAL = "#06D6A0";
const PURPLE = "#845EF7";
const CREAM = "#FFF8F0";
const ORANGE = "#FF9F1C";

/* Animated school bus SVG - Light and playful */
const BusSVG = () => (
  <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 380, height: "auto", animation: "floatY 3s ease-in-out infinite" }}>
    {/* Background */}
    <rect width="320" height="200" rx="16" fill="#E8F4F8" stroke={NAVY} strokeWidth="2.5" />

    {/* Clouds */}
    <circle cx="60" cy="35" r="18" fill="#fff" stroke={NAVY} strokeWidth="1.5" />
    <circle cx="80" cy="30" r="14" fill="#fff" stroke={NAVY} strokeWidth="1.5" />
    <circle cx="100" cy="35" r="16" fill="#fff" stroke={NAVY} strokeWidth="1.5" />

    <circle cx="240" cy="25" r="15" fill="#fff" stroke={NAVY} strokeWidth="1.5" />
    <circle cx="258" cy="22" r="12" fill="#fff" stroke={NAVY} strokeWidth="1.5" />
    <circle cx="276" cy="25" r="14" fill="#fff" stroke={NAVY} strokeWidth="1.5" />

    {/* Sun */}
    <circle cx="290" cy="50" r="20" fill={YELLOW} stroke={NAVY} strokeWidth="2" />
    {[0, 45, 90, 135, 180, 225, 270, 315].map(angle => (
      <line key={angle} x1="290" y1="50" x2={290 + 25 * Math.cos(angle * Math.PI / 180)} y2={50 + 25 * Math.sin(angle * Math.PI / 180)} stroke={YELLOW} strokeWidth="2.5" strokeLinecap="round" />
    ))}

    {/* Road */}
    <rect x="0" y="145" width="320" height="55" fill="#E0E0E0" stroke={NAVY} strokeWidth="2" />
    {[25, 75, 125, 175, 225, 275].map(x => (
      <rect key={x} x={x} y="170" width="30" height="5" fill={YELLOW} rx="2.5" stroke={NAVY} strokeWidth="1" />
    ))}

    {/* Bus */}
    <g style={{ animation: "floatY 2.5s ease-in-out infinite", transformOrigin: "160px 115px" }}>
      <rect x="30" y="80" width="240" height="75" rx="14" fill={YELLOW} stroke={NAVY} strokeWidth="3" />
      <rect x="30" y="80" width="52" height="75" rx="14" fill={CORAL} stroke={NAVY} strokeWidth="2.5" />

      {/* Windshield */}
      <rect x="42" y="95" width="28" height="24" rx="5" fill="#C8F5FF" stroke={NAVY} strokeWidth="2" />
      <rect x="48" y="100" width="16" height="2" rx="1" fill={NAVY} opacity="0.3" />

      {/* Windows */}
      {[100, 140, 180].map(x => (
        <g key={x}>
          <rect x={x} y="93" width="34" height="24" rx="5" fill="#C8F5FF" stroke={NAVY} strokeWidth="2" />
          <rect x={x + 6} y="100" width="22" height="2" rx="1" fill={NAVY} opacity="0.3" />
        </g>
      ))}

      {/* Smiley face in window */}
      <circle cx="168" cy="104" r="5" fill="#FDBCB4" stroke={NAVY} strokeWidth="1" />
      <circle cx="166" cy="103" r="1" fill={NAVY} />
      <circle cx="170" cy="103" r="1" fill={NAVY} />
      <path d="M165 107 Q168 110 171 107" stroke={NAVY} strokeWidth="1" strokeLinecap="round" fill="none" />

      {/* Wheels */}
      <circle cx="100" cy="150" r="18" fill={NAVY} />
      <circle cx="100" cy="150" r="9" fill="#999" />
      <circle cx="100" cy="150" r="4" fill={NAVY} />

      <circle cx="230" cy="150" r="18" fill={NAVY} />
      <circle cx="230" cy="150" r="9" fill="#999" />
      <circle cx="230" cy="150" r="4" fill={NAVY} />

      {/* Door */}
      <rect x="262" y="88" width="20" height="14" rx="4" fill={TEAL} stroke={NAVY} strokeWidth="2" />

      {/* Bus text */}
      <text x="110" y="128" fontFamily="Fredoka One, cursive" fontSize="13" fill={NAVY} fontWeight="bold">SCHOOL BUS</text>
    </g>

    {/* Decorative elements */}
    <text x="15" y="55" fontSize="18" style={{ animation: "starSpin 3s linear infinite" }}>⭐</text>
    <text x="175" y="45" fontSize="14" style={{ animation: "starSpin 3.5s linear infinite reverse" }}>✨</text>

    {/* Buildings in background */}
    <rect x="8" y="110" width="22" height="35" rx="3" fill={PURPLE} stroke={NAVY} strokeWidth="1.5" opacity="0.5" />
    <rect x="12" y="118" width="6" height="6" rx="1" fill="#fff" opacity="0.7" />
    <rect x="12" y="128" width="6" height="6" rx="1" fill="#fff" opacity="0.7" />

    <rect x="290" y="108" width="24" height="37" rx="3" fill={TEAL} stroke={NAVY} strokeWidth="1.5" opacity="0.5" />
    <rect x="295" y="116" width="6" height="6" rx="1" fill="#fff" opacity="0.7" />
    <rect x="295" y="126" width="6" height="6" rx="1" fill="#fff" opacity="0.7" />
  </svg>
);

const ICONS = ["🚌", "🛡️", "💚"];
const ICONS_ALT = ["📍", "⏰", "👨‍✈️"];
const COLORS = [YELLOW, TEAL, CORAL];
const SUBTITLES = ["Transport", "Safety First", "Well-being"];

const TransportSafetySection = ({ cards, schoolInfo }) => (
  <AnimatedSection sx={{ backgroundColor: CREAM, py: { xs: 9, md: 12 }, position: "relative", overflow: "hidden" }}>
    {/* Decorative background elements */}
    <Box sx={{ position: "absolute", top: -40, left: -40, width: 180, height: 180, borderRadius: "50%", backgroundColor: YELLOW, border: `3px solid ${NAVY}`, opacity: 0.08 }} />
    <Box sx={{ position: "absolute", bottom: -50, right: -50, width: 200, height: 200, borderRadius: "50%", backgroundColor: TEAL, border: `3px solid ${NAVY}`, opacity: 0.08 }} />
    <Box sx={{ position: "absolute", top: "30%", left: "3%", fontSize: "40px", opacity: 0.06, animation: "floatY 4s ease-in-out infinite" }}>🚦</Box>
    <Box sx={{ position: "absolute", bottom: "25%", right: "5%", fontSize: "35px", opacity: 0.06, animation: "floatY 3.5s ease-in-out infinite" }}>🅿️</Box>

    <Container maxWidth="xl" sx={{ position: "relative" }}>
      <SectionHeading
        eyebrow="Safety & Transport"
        title="Safe Journeys, Happy Arrivals 🚌"
        description="We give importance to the safety and comfort of every child during school hours and travel."
        eyebrowColor={CORAL}
        eyebrowBg="#FFE8E8"
      />

      <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
        {/* Left: Bus SVG and Address */}
        <Grid item xs={12} md={5}>
          <Box sx={{ position: "relative" }}>
            <Box sx={{
              position: "absolute", top: -16, left: -16, width: "100%", height: "100%",
              borderRadius: "24px", border: `4px solid ${NAVY}`, backgroundColor: YELLOW, zIndex: 0
            }} />
            <Box sx={{ position: "relative", zIndex: 1, borderRadius: "20px", border: `3px solid ${NAVY}`, overflow: "hidden", boxShadow: `5px 5px 0 ${NAVY}`, backgroundColor: "#E8F4F8" }}>
              <BusSVG />
            </Box>
          </Box>

          {/* Address card */}
          <Box sx={{
            mt: 3,
            p: 3,
            borderRadius: "16px",
            border: `2.5px solid ${NAVY}`,
            backgroundColor: "#fff",
            boxShadow: `5px 5px 0 ${YELLOW}`,
            transition: "all 0.2s ease",
            "&:hover": {
              transform: "translate(-2px,-2px)",
              boxShadow: `7px 7px 0 ${YELLOW}`,
            }
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
              <Box sx={{
                width: 40,
                height: 40,
                borderRadius: "10px",
                backgroundColor: `${YELLOW}20`,
                border: `2px solid ${YELLOW}`,
                display: "grid",
                placeItems: "center",
                fontSize: "1.2rem",
                boxShadow: `2px 2px 0 ${YELLOW}`,
              }}>
                📍
              </Box>
              <Typography sx={{
                fontFamily: "'Fredoka One', cursive",
                fontSize: "1.1rem",
                color: NAVY,
              }}>
                School Address
              </Typography>
            </Box>
            <Typography sx={{
              color: "#4A4E6D",
              fontWeight: 600,
              lineHeight: 1.9,
              fontSize: "0.9rem",
              pl: 0.5,
            }}>
              {schoolInfo.addressLines.join(", ")}
            </Typography>
          </Box>
        </Grid>

        {/* Right: Safety Cards */}
        <Grid item xs={12} md={7}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            {cards.map((c, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  gap: 2.5,
                  p: 3,
                  borderRadius: "16px",
                  border: `2.5px solid ${NAVY}`,
                  backgroundColor: "#fff",
                  boxShadow: `5px 5px 0 ${COLORS[i]}`,
                  transition: "all 0.25s ease",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    transform: "translate(-3px,-3px)",
                    boxShadow: `8px 8px 0 ${COLORS[i]}`,
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "4px",
                    height: "100%",
                    backgroundColor: COLORS[i],
                    borderRadius: "4px 0 0 4px",
                  }
                }}
              >
                <Box sx={{
                  width: 56,
                  height: 56,
                  flexShrink: 0,
                  borderRadius: "14px",
                  backgroundColor: COLORS[i],
                  border: `2.5px solid ${NAVY}`,
                  display: "grid",
                  placeItems: "center",
                  fontSize: "1.6rem",
                  boxShadow: `3px 3px 0 ${NAVY}`,
                  animation: `wiggle ${2.5 + i * 0.4}s ease-in-out infinite`,
                }}>
                  {ICONS[i]}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                    <Typography sx={{
                      fontFamily: "'Fredoka One', cursive",
                      fontSize: "1.15rem",
                      color: NAVY,
                    }}>
                      {c.title}
                    </Typography>
                    <Typography sx={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontSize: "0.65rem",
                      fontWeight: 800,
                      color: COLORS[i],
                      textTransform: "uppercase",
                      letterSpacing: "0.08em",
                      backgroundColor: `${COLORS[i]}15`,
                      px: 1,
                      py: 0.2,
                      borderRadius: "5px",
                      border: `1px solid ${COLORS[i]}40`,
                    }}>
                      {SUBTITLES[i]}
                    </Typography>
                  </Box>
                  <Typography sx={{
                    color: "#4A4E6D",
                    fontWeight: 600,
                    lineHeight: 1.8,
                    fontSize: "0.9rem",
                  }}>
                    {c.description}
                  </Typography>
                </Box>
                {/* Decorative element */}
                <Typography sx={{
                  position: "absolute",
                  top: 10,
                  right: 12,
                  fontSize: "1.2rem",
                  opacity: 0.1,
                }}>
                  {ICONS_ALT[i]}
                </Typography>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Container>
  </AnimatedSection>
);

export default TransportSafetySection;